import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Card, CardContent, CardActions,
  Button, Avatar
} from '@mui/material';
import {
  People as CRMCoreIcon,
  Storefront as SFAIcon,
  SupportAgent as HelpDeskIcon,
  AccountBalance as FinanceIcon,
  EventNote as ActivityCommIcon,
  ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

const CRMLandingPage = () => {
  const { chatbotId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'CRM | KlonIT Web Application';
  }, []);

  const cards = [
    {
      title: 'CRM Core',
      description: 'Manage contacts, accounts, leads, and track customer relationships with activity logging and pipeline management.',
      icon: <CRMCoreIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      link: `/chatbot/${chatbotId}/crm`,
      color: '#1976d2'
    },
    {
      title: 'Sales Force Automation',
      description: 'Manage opportunities, quotes, products, forecasts, sales targets, and team territories to drive revenue growth.',
      icon: <SFAIcon sx={{ fontSize: 60, color: '#2e7d32' }} />,
      link: `/chatbot/${chatbotId}/sfa-dashboard`,
      color: '#2e7d32'
    },
    {
      title: 'Finance',
      description: 'Track invoices, payments, outstanding balances, and manage financial records for your CRM contacts.',
      icon: <FinanceIcon sx={{ fontSize: 60, color: '#e65100' }} />,
      link: `/chatbot/${chatbotId}/crm/finance`,
      color: '#e65100'
    },
    {
      title: 'Help Desk',
      description: 'Handle support tickets, SLA policies, ticket categories, and build a knowledge base for customer self-service.',
      icon: <HelpDeskIcon sx={{ fontSize: 60, color: '#9c27b0' }} />,
      link: `/chatbot/${chatbotId}/helpdesk`,
      color: '#9c27b0'
    },
    {
      title: 'Activity & Communications',
      description: 'Manage tasks, calendar events, booking pages, and track all email, call, and SMS communications.',
      icon: <ActivityCommIcon sx={{ fontSize: 60, color: '#ed6c02' }} />,
      link: `/chatbot/${chatbotId}/activity-dashboard`,
      color: '#ed6c02'
    }
  ];

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 }, mt: { xs: 2, sm: 10 } }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700} sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
          CRM
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Customer Relationship Management
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: '0.3s',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-4px)'
                }
              }}
              onClick={() => navigate(card.link)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 4 }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: `${card.color}15`,
                    margin: '0 auto 16px'
                  }}
                >
                  {card.icon}
                </Avatar>
                <Typography variant="h5" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ bgcolor: card.color }}
                >
                  Open
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CRMLandingPage;
